module.exports = __webpack_public_path__ + "img/HODL.510e0431.svg";